import React, {useRef} from 'react';
import Accordion from "react-bootstrap/Accordion";
import {
    faMapMarkedAlt,
    faShieldAlt,
    faCouch,
    faCity,
    faBuilding,
    faWalking,
    faLeaf,
    faWifi,
    faVideo,
    faSmileBeam,
    faLock,
    faBed,
    faMoneyBillAlt,
    faCreditCard, faCalendarAlt, faMapMarkerAlt, faSquarePhone, faHotel
} from '@fortawesome/free-solid-svg-icons';
import ResponsiveSlider from "../AdvantagesSlider/AdvantagesSlider";
import CardContainer from "../CardContainer/CardContainer";
import ThumbsSlider from "../ThumbsSlider/ThumbsSlider";
import InfoModal from "../InfoModal/InfoModal";
import {Link} from "react-router-dom";


const App9 = () => {
    const advantages = [
        {id: 1, title: "Удобное расположение", icon: faMapMarkedAlt},
        {id: 2, title: "Охраняемая территория", icon: faShieldAlt},
        {id: 3, title: "Обеспечен пропускной режим", icon: faLock},
        {id: 4, title: "Круглосуточное видеонаблюдение", icon: faVideo},
        {id: 5, title: "Комфортная среда", icon: faCouch},
        {id: 6, title: "Много активностей", icon: faSmileBeam},
        {id: 7, title: "Хороший район", icon: faCity},
        {id: 8, title: "Безлимитный интернет", icon: faWifi},
        {id: 9, title: "Развитая инфраструктура", icon: faBuilding},
        {id: 10, title: "В шаговой доступности от учебного заведения", icon: faWalking},
        {id: 11, title: "Экологически чистый район", icon: faLeaf},
    ];

    const checkinInformation = [
        {
            id: 1, title: "Стоимость проживания", icon: faCreditCard, description: (
                <>
                    <p>
                        1520 руб. в месяц для обучающихся на бюджетной основе<br/>
                        2750 руб. в месяц для обучающихся на договорной основе.<br/>
                        <a href="https://www.art-gzhel.ru/sveden/grants/obshezitiya/doc/poryadok_oplatu_za_progivanie_11_06_2025.pdf"
                           target={"_blank"} rel="noopener noreferrer">
                            Подробнее
                        </a>.
                    </p>
                </>
            )
        },
        {
            id: 2,
            title: "Оплата проживания",
            icon: faMoneyBillAlt,
            description: (
                <>
                    <p>
                        Первый семестр оплачивается при заселении, второй – до 1 февраля следующего года.
                    </p>
                </>
            )
        },
        {
            id: 3,
            title: "Даты заселения",
            icon: faCalendarAlt,
            description: (
                <p>
                    Студенты заселяются в общежитие с 29 августа.
                    {" "}
                    <Link
                        to="#"
                        onClick={(e) => {
                            e.preventDefault();
                            modalRef.current.openModal();
                        }}
                    >
                        Подробнее
                    </Link>.
                </p>
            )
        },
        {
            id: 4,
            title: "Количество мест",
            icon: faBed,
            description: (
                <>
                    <p>Для иногородних поступающих – 150 мест, для инвалидов и лиц с ОВЗ - 3 места.</p>
                </>
            )
        },
        {
            id: 5,
            title: "Для поступающих",
            icon: faHotel,
            description: (
                <>
                    <p>Для иногородних поступающих на время сдачи вступительный испытаний предоставляется общежитие. Стоимость проживания – 230 руб./сутки</p>
                </>
            )
        }
    ];

    const hostelAddresses = [
        {
            id: 1,
            icon: faMapMarkerAlt,
            title: "Общежитие № 1",
            description: "Московская обл., Раменский городской округ, пос. Электроизолятор, д. 67/2"
        },
        {
            id: 1,
            icon: faMapMarkerAlt,
            title: "Общежитие № 2",
            description: "Московская обл., Раменский городской округ, пос. Электроизолятор, д. 65"
        },
        {
            id: 3,
            icon: faMapMarkerAlt,
            title: "Общежитие № 3",
            description: "Московская обл., Раменский городской округ, пос. Электроизолятор, д. 66"
        }
    ];

    const hostelImages = [
        '/images/hostel/1.webp',
        '/images/hostel/2.webp',
        '/images/hostel/3.webp',
        '/images/hostel/4.webp',
        '/images/hostel/5.webp',
    ];

    const hostelContacts = [
        {
            id: 1,
            icon: faSquarePhone,
            title: "Общежитие № 1",
            description: (
                <>
                    Игнатьева <br/>Юлия Алексеевна<br/> +7 (916) 115-62-87
                </>
            )
        },
        {
            id: 2,
            icon: faSquarePhone,
            title: "Общежитие № 2",
            description: (
                <>
                    Козулицына <br/>Татьяна Владимировна<br/>+7 (464) 469-73-97
                </>
            )
        },
        {
            id: 3,
            icon: faSquarePhone,
            title: "Общежитие № 3",
            description: (
                <>
                    Данилова <br/>Елена Борисовна<br/> +7 (496) 464-76-34
                </>
            )
        }
    ];

    const modalRef = useRef(null);

    const hostelCheckInTitle = "Порядок заселения в общежития"
    const hostelCheckInDescription = (
        <>
            <p>Студенты заселяются в общежитие с <strong>29 августа</strong>:</p>

            <ul>
                <li>
                    <strong>29 и 30 августа 2025 г.</strong> – заселение студентов из категорий:
                    <ul>
                        <li>дети-сироты и дети, оставшиеся без попечения родителей;</li>
                        <li>иностранные студенты;</li>
                        <li>студенты из других субъектов РФ;</li>
                        <li>дети-студенты участников СВО.</li>
                    </ul>
                    <em>(Согласно опубликованному списку)</em>
                </li>

                <li>
                    <strong>31 августа (воскресенье)</strong> – заселение <strong>не производится</strong> (ни для первокурсников, ни для старших курсов).
                </li>

                <li>
                    <strong>После 11 сентября</strong> – заселение студентов из Москвы и Московской области:
                    <ul>
                        <li>при удаленности места жительства от университета;</li>
                        <li>если требуется более 2-х видов транспорта для доезда;</li>
                        <li><strong>только при наличии свободных мест</strong>.</li>
                    </ul>
                </li>
            </ul>
        </>
    );

    return (
        <div className="DocumentLinksPage__content-container">
            <h2>Общежитие</h2>
            <p>Мы предлагаем комфортное проживание и благоприятные условия в непосредственной близости от места учебы.
                Ознакомьтесь с преимуществами наших общежитий:</p>
            <div style={{display: "flex", justifyContent: "center"}}>
                <ResponsiveSlider items={advantages}/>
            </div>
            <p>
                Наши общежития созданы для того, чтобы каждый студент чувствовал себя как дома
                и мог полностью сосредоточиться на учебе и развитии личности.
            </p>
            <h5>Необходимые документы и порядок предоставления</h5>
            <p>Здесь можно ознакомиться с порядком предоставления общежития и необходимыми
                документами для заселения.</p>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Документы для заселения</Accordion.Header>
                    <Accordion.Body>
                        <p>Для заселения в общежитие необходимо предоставить следующие документы:
                            <ul>
                                <li>
                                    паспорт и копии 2, 3 и 5 страниц в 2-х экземплярах
                                </li>
                                <li>
                                    медицинский полис и его двухсторонние копии в 2-х экземплярах
                                </li>
                                <li>
                                    справка 0-86У с обязательной отметкой прививок и справка от врача дерматолога,
                                    выданная не позднее, чем за 10 дней до даты заселения
                                </li>
                                <li>результат флюорографического обследования за последний год не позднее 10 мес.</li>
                                <li>справка осмотра дерматолога об отсутствии кожных заболеваний, выданная не позднее,
                                    чем за 10 дней до даты заселения
                                </li>
                            </ul>
                        </p>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>Порядок предоставления общежития</Accordion.Header>
                    <Accordion.Body>
                        <ul>
                            <li><a
                                href="https://www.art-gzhel.ru/sveden/grants/obshezitiya/doc/Pol_st_dorm_12_05_2025.pdf" rel="noopener noreferrer">
                                Положения о студенческом общежитии</a>
                            </li>
                            <li><a
                                href="https://www.art-gzhel.ru/sveden/grants/obshezitiya/doc/Pol_usl_pred_12_05_2025.pdf" rel="noopener noreferrer">
                                Порядок предоставления жилых помещений в студенческих общежитиях</a>
                            </li>
                            <li><a href="https://www.art-gzhel.ru/download/Zayavka_zaselenie.pdf" rel="noopener noreferrer">Образец заявления на
                                предоставление места в общежитии</a></li>
                            <li><a href="https://www.art-gzhel.ru/download/rvvbbzbwmeqi3uf.pdf" rel="noopener noreferrer">Образец договора найма
                                жилого помещения в студенческом общежитии</a></li>
                            <li><a href="https://www.art-gzhel.ru/download/Prav_raspor_2025.pdf" rel="noopener noreferrer">
                                Правила внутреннего распорядка в общежитии
                            </a>
                            </li>
                            <li><a
                                href="https://www.art-gzhel.ru/sveden/grants/obshezitiya/doc/poryadok_oplatu_za_progivanie_11_06_2025.pdf" rel="noopener noreferrer">
                                Приказ об установлении размера платы студентам за общежитие
                            </a>
                            </li>
                        </ul>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <h5>Краткая информация</h5>
            <CardContainer items={checkinInformation}/>
            <h5>Адреса общежитий</h5>
            <p>
                Все общежития находятся в шаговой доступности от места учеба.
            </p>
            <CardContainer items={hostelAddresses}/>
            <h5>Галерея</h5>
            <p>
                В этом разделе Вы найдете фотографии, которые помогут Вам представить условия проживания в наших общежитиях.
            </p>
            <ThumbsSlider
                images={hostelImages}
                popupFullPhoto={true}
            />
            <h5>Контакты</h5>
            <p>
                Если у Вас остались вопросы, свяжитесь с заведующими наших общежитий.
            </p>
            <CardContainer items={hostelContacts} isContactLayout={true}/>
            <InfoModal
                ref={modalRef}
                title={hostelCheckInTitle}
                description={hostelCheckInDescription}
            />
        </div>
    );
}

export default App9;
